import React, { useState, useEffect } from 'react'
import './Timeline.css'
import { useTranslation } from 'react-i18next'
import { FaFileInvoiceDollar } from 'react-icons/fa'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { Link } from 'components/common'
import { useContext } from 'react'
import { TubularContext } from 'stores/TubularStore'

const BillingCard = ({ data }) => {
    const { t } = useTranslation()
    const history = useHistory()
    const [selectDetail, setSelectDetail] = useState('')
    const { setValueData } = useContext(TubularContext)
    useEffect(() => {
        if (selectDetail === 'invoice') {
            setValueData(data.detail['Invoice Number'])
            history.push("/invoice/" + data.detail['Invoice Number'])
        } else if (selectDetail === 'purchase') {
            setValueData(data.detail['Customer Order'])
            history.push("/purchaseOrder/" + data.detail['Customer Order'])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectDetail, history])

    const toGo = (value) => {
        setSelectDetail(value)
    }
    const content =
        <div className="timeline-item-content">
            <span className="title">
                <FaFileInvoiceDollar className="icon" />
                {t('tlh.ippn.billing.title')}
            </span>
            <section className="container row">
                <div className="item">
                    <span className="label">{t('tlh.ippn.billing.origin')}: </span>
                    <span className="value">{data.detail['Origin']}</span>
                </div>
            </section>
            <section className="container row">
                <div className="item">
                    <span className="label">{t('tlh.ippn.billing.customer')}: </span>
                    <span className="value">{data.detail['Customer']}</span>
                </div>
            </section>
            <section className="container row">
                <div className="item">
                    <span className="label">{t('tlh.ippn.billing.customerOrder')}: </span>
                    <span className="value">
                        <Link onClick={() => toGo('purchase')}>
                            {data.detail['Customer Order']}
                        </Link>
                    </span>
                </div>
                <div className="item">
                    <span className="label">{t('tlh.ippn.billing.invoice')}: </span>
                    <span className="value">
                        <Link onClick={() => toGo('invoice')}>
                            {data.detail['Invoice Number']}
                        </Link>
                    </span>
                </div>
            </section>
            <span className="circle" > {moment(data.date).format('DD/MM/YYYY')} </span>
        </div>
    return content
}

export default BillingCard